import { initCarousels } from "../carousel/";

// ============================================================================
// Home page carousel wiring
// ============================================================================

// ---- HERO ------------------------------------------------------------------
document.addEventListener("DOMContentLoaded", function () {
  initCarousels(".home-hero__slider", {
    fade: true,
    contain: true,
    pageDots: false,
    wrapAround: true,
    autoPlay: 3800,
  });
});

// ---- SERVICE ---------------------------------------------------------------
document.addEventListener("DOMContentLoaded", function () {
  // 1. Initialize via the engine (it handles display: block and image fallbacks automatically)
  const instances = initCarousels(".home-service__card", {
    cellAlign: "left",
    contain: true,
    pageDots: false,
    wrapAround: false,
  });

  // 2. Map your custom external navigation buttons using the returned instance
  if (instances && instances.length > 0) {
    const sliderFlic = instances[0].flickity;

    const sliderNavPrevEl = document.querySelector(
      ".home-service__card-button--prev",
    );
    const sliderNavNextEl = document.querySelector(
      ".home-service__card-button--next",
    );

    if (sliderNavPrevEl) {
      sliderNavPrevEl.addEventListener("click", function () {
        sliderFlic.previous();
      });
    }

    if (sliderNavNextEl) {
      sliderNavNextEl.addEventListener("click", function () {
        sliderFlic.next();
      });
    }
  }
});

// ---- RESIDENTIAL -----------------------------------------------------------
document.addEventListener("DOMContentLoaded", function () {
  // 1. Boot up the gallery with the engine
  const instances = initCarousels(".home-residential__gallery", {
    cellAlign: "center",
    contain: true,
    pageDots: false,
    wrapAround: true,
  });

  // 2. Wrap all custom content-swapping logic inside the instance check
  if (instances && instances.length > 0) {
    const slider = instances[0].flickity;

    // CONFIGURATION: Define your fallback default background image URL here
    const defaultBgImg =
      "http://manon.local/wp-content/uploads/2026/01/default-fallback.jpg";

    const buttonSliderPrev = document.querySelectorAll(
      ".home-residential__button--prev",
    );
    const buttonSliderNext = document.querySelectorAll(
      ".home-residential__button--next",
    );

    const sliderImg = document.querySelector(".home-residential__bg");
    const sliderTitle = document.querySelector(
      ".home-residential__content-title",
    );
    const sliderDescription = document.querySelector(
      ".home-residential__content-description",
    );

    // Content swapping function executed on slide change
    function onSliderChange() {
      var currentItemEl = slider.selectedElement;
      if (!currentItemEl) return;

      if (!currentItemEl.classList.contains("home-residential__gallery-item")) {
        currentItemEl =
          currentItemEl.querySelector(".home-residential__gallery-item") ||
          currentItemEl;
      }

      var title = currentItemEl.getAttribute("title");
      var description = currentItemEl.getAttribute("description");

      // FIX: Use the slide attribute image, or fall back to the default image if empty
      var img = currentItemEl.getAttribute("img") || defaultBgImg;

      // Update background image safely
      if (sliderImg && img) {
        sliderImg.src = img;
      }

      // Update Title with text fade animation
      if (sliderTitle) {
        sliderTitle.style.opacity = "0";
        setTimeout(function () {
          sliderTitle.innerText = title || "";
          sliderTitle.style.opacity = "1";
        }, 300);
      }

      // Update Description with text fade animation
      if (sliderDescription) {
        sliderDescription.style.opacity = "0";
        setTimeout(function () {
          sliderDescription.innerText = description || "";
          sliderDescription.style.opacity = "1";
        }, 300);
      }
    }

    // Bind event tracking and fire initial frame
    slider.on("change", onSliderChange);

    // Flickity settles on load, but let's run the initial setup frame once images are ready
    slider.on("ready", onSliderChange);
    onSliderChange();

    // Map navigation elements arrays safely
    buttonSliderPrev.forEach(function (el) {
      el.addEventListener("click", function () {
        slider.previous();
      });
    });

    buttonSliderNext.forEach(function (el) {
      el.addEventListener("click", function () {
        slider.next();
      });
    });
  }
});

// ---- PORTFOLIO -------------------------------------------------------------
document.addEventListener("DOMContentLoaded", function () {
  // 1. Boot up the portfolio slider with the engine
  const instances = initCarousels(".home-portfolio__slider", {
    contain: true,
    pageDots: false,
    wrapAround: true,
  });

  // 2. Wrap custom content tracking inside the instance check
  if (instances && instances.length > 0) {
    const slider = instances[0].flickity;

    const buttonSliderPrev = document.querySelectorAll(
      ".home-portfolio__button--prev",
    );
    const buttonSliderNext = document.querySelectorAll(
      ".home-portfolio__button--next",
    );

    const sliderTitleEl = document.querySelector(".home-portfolio__title");
    const sliderDescriptionEl = document.querySelector(
      ".home-portfolio__description",
    );

    // Content swapping function executed on slide change
    function onSliderChange() {
      // Safely grab the current active element directly from Flickity's API
      var currentItemEl = slider.selectedElement;
      if (!currentItemEl) return;

      // Drill down if the engine wrapped the slide block layout item
      if (!currentItemEl.classList.contains("home-portfolio__slide")) {
        currentItemEl =
          currentItemEl.querySelector(".home-portfolio__slide") ||
          currentItemEl;
      }

      var title = currentItemEl.getAttribute("title");
      var description = currentItemEl.getAttribute("description");

      // Update Title with text fade animation
      if (sliderTitleEl) {
        sliderTitleEl.style.opacity = "0";
        setTimeout(function () {
          sliderTitleEl.innerText = title || "";
          sliderTitleEl.style.opacity = "1";
        }, 300);
      }

      // Update Description with text fade animation
      if (sliderDescriptionEl) {
        sliderDescriptionEl.style.opacity = "0";
        setTimeout(function () {
          sliderDescriptionEl.innerText = description || "";
          sliderDescriptionEl.style.opacity = "1";
        }, 300);
      }
    }

    // Bind content swapping hooks to Flickity
    slider.on("change", onSliderChange);

    // Initial frame execution
    onSliderChange();

    // Map navigation elements arrays safely
    buttonSliderPrev.forEach(function (el) {
      el.addEventListener("click", function () {
        slider.previous();
      });
    });

    buttonSliderNext.forEach(function (el) {
      el.addEventListener("click", function () {
        slider.next();
      });
    });
  }
});

// ---- CLIENTS ---------------------------------------------------------------
document.addEventListener("DOMContentLoaded", function () {
  initCarousels(".home-clients__slider", {
    cellAlign: "left",
    contain: true,
    pageDots: false,
    wrapAround: true,
    autoPlay: 1000, // Fixed lowercase 'p' typo to match Flickity's case-sensitive autoPlay API
  });
});

// ---- REVIEW ----------------------------------------------------------------
document.addEventListener("DOMContentLoaded", function () {
  // 1. Boot up the review slider using the engine
  const instances = initCarousels(".home-review__slider", {
    contain: true,
    pageDots: false,
    wrapAround: true,
  });

  // 2. Wire up the navigation elements if initialization was successful
  if (instances && instances.length > 0) {
    const slider = instances[0].flickity;

    const buttonSliderPrev = document.querySelectorAll(
      ".home-review__button--prev",
    );
    const buttonSliderNext = document.querySelectorAll(
      ".home-review__button--next",
    );

    buttonSliderPrev.forEach(function (el) {
      el.addEventListener("click", function () {
        slider.previous();
      });
    });

    buttonSliderNext.forEach(function (el) {
      el.addEventListener("click", function () {
        slider.next();
      });
    });
  }
});
